module.exports = __webpack_public_path__ + "static/media/logo_side_pleteo.acb24418.png";